import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const spendMetricsResponse = z.object({
  total_spend: z.number(),
  bonus_spend: z.number(),
  wages_spend: z.number(),
  other_spend_or_discount: z.number(),
})

export type SpendMetrics = z.infer<typeof spendMetricsResponse>

export async function getSpendMetrics(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_metrics', data, { signal })
    .then((response) => response.data)
    .then(spendMetricsResponse.parse)
}
